/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import cn from "clsx";
import { NavLink } from "react-router-dom";
import { ReactComponent as ArrowRight } from "cms/assets/icons/arrow-right.svg";
import { housingPermitOptions } from "./housing-permit-options";

const PermitSelectComponent = (props) => {

    const { component } = props || {};
    const { selected_type = "housing" } = component;

    return (
        <div className='permit-select-container'>
            <p>What type of {selected_type} permit would you like to apply for?</p>
            <div className='permit-selector'>
                {housingPermitOptions.map((permitType, index) => {
                    const { type, applicationLink } = permitType;
                    const permitOptionClass = cn("permit-option", { disabled: !applicationLink });
                    return (
                        <NavLink
                            className={permitOptionClass}
                            to={applicationLink}
                            key={`${permitType}${index}`}
                        >
                            {type}
                            <ArrowRight alt='right-arrow'/>
                        </NavLink>
                    );
                })}
            </div>
        </div>
    );
};

PermitSelectComponent.displayName = "PermitSelectComponent";
export { PermitSelectComponent };
